// extracted by mini-css-extract-plugin
export var usersGroupsHeader = "users-groups-header_HNVhUXZS44L0sHq2bKE_";
export var usersGroupsHeaderTabs = "users-groups-header__tabs_RTvi6MiIMD0Q7lqdRvPb";
export var usersGroupsHeaderTabsContainer = "users-groups-header__tabs-container_Xt2HGBG9mj8lb0NO3Lj9";